import type { RequestMiddleware } from './gqlEngineUtils';
import { getObjectSelection } from './gqlObjectSelection';
import { AppLanguage } from '../i18n/languages';

export const gqlXLanguageMiddleware = (language: AppLanguage): RequestMiddleware => {
	return (next) => (request) => {
		const objectSelection = getObjectSelection(request.info, request.context.variables);
		if (!objectSelection) return next(request);

		const {
			groupedVariables: { header, ...otherGroupedVariables },
			...otherRequest
		} = request;

		return next({
			...otherRequest,
			groupedVariables: {
				header: {
					...header,
					'X-Language': language,
				},
				...otherGroupedVariables,
			},
		});
	};
};
